export default "__VITE_ASSET__adc49558__"